import { useState, useEffect } from "react";
import { collection, getDocs, doc, setDoc, updateDoc, deleteDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/config";

const G = {
  bg:"#FAF9F7",s1:"#FFFFFF",s2:"#F4F2EF",border:"#E2DFD9",border2:"#D4D0CA",
  black:"#1C1917",off:"#3D3830",muted:"#8C8078",dim:"#C8C0B8",
  orange:"#D2611A",green:"#16A34A",red:"#DC2626",amber:"#D97706",blue:"#2563EB",
  sans:"'Outfit','Helvetica Neue',Arial,sans-serif",
  mono:"'IBM Plex Mono',monospace",
};

const RUBROS_DEFAULT = [
  { id:"porcelanato",    nombre:"Porcelanato",          icono:"◼", orden:1,  activo:true },
  { id:"pisos-spc",     nombre:"Pisos SPC",             icono:"▦", orden:2,  activo:true },
  { id:"sanitarios",    nombre:"Sanitarios",            icono:"◻", orden:3,  activo:true },
  { id:"baneras",       nombre:"Bañeras",               icono:"◇", orden:4,  activo:true },
  { id:"vanitorys",     nombre:"Vanitorys",             icono:"◈", orden:5,  activo:true },
  { id:"cocinas",       nombre:"Cocinas integrales",    icono:"◉", orden:6,  activo:true },
  { id:"hornos",        nombre:"Hornos y Anafes",       icono:"⬡", orden:7,  activo:true },
  { id:"puertas",       nombre:"Puertas WPC / MDF",     icono:"▤", orden:8,  activo:true },
  { id:"carpinteria",   nombre:"Carpintería",           icono:"▱", orden:9,  activo:true },
];

function ModalCategoria({ cat, onGuardar, onClose }) {
  const [form, setForm] = useState(cat ? { ...cat } : { nombre:"", icono:"◻", orden:10, activo:true, descripcion:"" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const guardar = async () => {
    if (!form.nombre.trim()) { setError("El nombre es obligatorio."); return; }
    setSaving(true);
    const id = cat?.id || form.nombre.toLowerCase().replace(/\s+/g,"-").replace(/[^a-z0-9-]/g,"");
    await setDoc(doc(db,"categorias",id), {
      ...form,
      nombre:    form.nombre.trim(),
      orden:     parseInt(form.orden)||10,
      updatedAt: serverTimestamp(),
      creadoEn:  cat?.creadoEn || serverTimestamp(),
    });
    setSaving(false);
    onGuardar();
  };

  const inp = { width:"100%", background:"transparent", border:"none", borderBottom:`1.5px solid ${G.border2}`, color:G.black, fontFamily:G.sans, fontSize:13, padding:"8px 0", outline:"none", fontWeight:400 };
  const lbl = { fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", color:G.muted, marginBottom:5, fontWeight:600, display:"block" };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(28,25,23,.5)", zIndex:300, display:"flex", alignItems:"center", justifyContent:"center" }}>
      <div style={{ background:G.s1, border:`1.5px solid ${G.border}`, padding:"32px 36px", width:420, maxWidth:"95vw" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
          <div style={{ fontFamily:G.sans, fontSize:18, color:G.black, fontWeight:700 }}>
            {cat ? "Editar categoría" : "Nueva categoría"}
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:20, color:G.muted, cursor:"pointer" }}>×</button>
        </div>

        <div style={{ marginBottom:16 }}>
          <label style={lbl}>Nombre *</label>
          <input value={form.nombre} onChange={e=>setForm(p=>({...p,nombre:e.target.value}))} placeholder="Ej: Porcelanato" style={inp}
            onFocus={e=>e.target.style.borderBottomColor=G.orange} onBlur={e=>e.target.style.borderBottomColor=G.border2}/>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
          <div>
            <label style={lbl}>Ícono</label>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:4 }}>
              {["◼","◻","▦","◇","◈","◉","⬡","▤","▱","▸","◎","★","⊕","⊗"].map(ic=>(
                <div key={ic} onClick={()=>setForm(p=>({...p,icono:ic}))}
                  style={{ width:32, height:32, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, cursor:"pointer", background:form.icono===ic?G.orange:G.s2, color:form.icono===ic?"#fff":G.muted, border:`1px solid ${form.icono===ic?G.orange:G.border}`, borderRadius:4 }}>
                  {ic}
                </div>
              ))}
            </div>
          </div>
          <div>
            <label style={lbl}>Orden de aparición</label>
            <input type="number" value={form.orden} onChange={e=>setForm(p=>({...p,orden:e.target.value}))} placeholder="1" style={inp}
              onFocus={e=>e.target.style.borderBottomColor=G.orange} onBlur={e=>e.target.style.borderBottomColor=G.border2}/>
          </div>
        </div>

        <div style={{ marginBottom:16 }}>
          <label style={lbl}>Descripción (opcional)</label>
          <input value={form.descripcion||""} onChange={e=>setForm(p=>({...p,descripcion:e.target.value}))} placeholder="Porcelanato de gran formato rectificado..." style={inp}
            onFocus={e=>e.target.style.borderBottomColor=G.orange} onBlur={e=>e.target.style.borderBottomColor=G.border2}/>
        </div>

        <div style={{ marginBottom:24 }}>
          <label style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer" }}>
            <input type="checkbox" checked={form.activo} onChange={e=>setForm(p=>({...p,activo:e.target.checked}))}/>
            <span style={{ fontFamily:G.sans, fontSize:12, color:G.off }}>Categoría activa (visible en el catálogo)</span>
          </label>
        </div>

        {error && <div style={{ fontFamily:G.sans, fontSize:11, color:G.red, marginBottom:16, padding:"8px 10px", background:"#FEF2F2" }}>{error}</div>}

        <div style={{ display:"flex", gap:10 }}>
          <button onClick={guardar} disabled={saving} style={{ flex:1, padding:"10px 0", background:G.orange, color:"#fff", fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", border:"none", cursor:"pointer", fontWeight:700 }}>
            {saving ? "Guardando..." : "Guardar →"}
          </button>
          <button onClick={onClose} style={{ padding:"10px 16px", background:"transparent", color:G.muted, fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", border:`1.5px solid ${G.border}`, cursor:"pointer" }}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default function AdminCategorias() {
  const [cats,     setCats]     = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [modal,    setModal]    = useState(null); // null | "nueva" | cat-obj
  const [cargando, setCargando] = useState(false);

  const cargar = async () => {
    setLoading(true);
    const snap = await getDocs(collection(db,"categorias")).catch(()=>({docs:[]}));
    let items = snap.docs.map(d=>({id:d.id,...d.data()}));
    // Si no hay categorías en Firestore, usar las default
    if (items.length === 0) items = RUBROS_DEFAULT;
    items.sort((a,b)=>(a.orden||99)-(b.orden||99));
    setCats(items);
    setLoading(false);
  };

  useEffect(()=>{ cargar(); },[]);

  const sembrar = async () => {
    setCargando(true);
    for (const cat of RUBROS_DEFAULT) {
      await setDoc(doc(db,"categorias",cat.id), { ...cat, creadoEn:serverTimestamp(), updatedAt:serverTimestamp() });
    }
    setCargando(false);
    cargar();
  };

  const toggleActivo = async (cat) => {
    await updateDoc(doc(db,"categorias",cat.id), { activo:!cat.activo, updatedAt:serverTimestamp() });
    cargar();
  };

  const eliminar = async (cat) => {
    if (!window.confirm(`¿Eliminar la categoría "${cat.nombre}"?`)) return;
    await deleteDoc(doc(db,"categorias",cat.id));
    cargar();
  };

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
        <div>
          <div style={{ fontFamily:G.sans, fontSize:22, color:G.black, fontWeight:700, marginBottom:3 }}>Categorías de productos</div>
          <div style={{ fontFamily:G.mono, fontSize:10, color:G.muted }}>{cats.filter(c=>c.activo).length} activas · {cats.length} totales</div>
        </div>
        <div style={{ display:"flex", gap:8 }}>
          {cats.length === 0 && (
            <button onClick={sembrar} disabled={cargando} style={{ padding:"8px 16px", background:G.blue, color:"#fff", fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", border:"none", cursor:"pointer", fontWeight:700 }}>
              {cargando ? "Cargando..." : "Cargar categorías default"}
            </button>
          )}
          <button onClick={()=>setModal("nueva")} style={{ padding:"9px 22px", background:G.orange, color:"#fff", fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", border:"none", cursor:"pointer", fontWeight:700 }}>
            + Nueva categoría
          </button>
        </div>
      </div>

      {/* Instrucción */}
      <div style={{ background:"#FEF3E8", border:`1px solid ${G.orange}33`, padding:"12px 16px", marginBottom:20, fontFamily:G.sans, fontSize:12, color:G.off, lineHeight:1.6 }}>
        Las categorías definen los rubros disponibles al crear productos y se muestran en el catálogo del comprador. El orden de aparición se controla con el número de orden.
      </div>

      {loading ? (
        <div style={{ padding:40, textAlign:"center", fontFamily:G.sans, fontSize:12, color:G.muted }}>Cargando...</div>
      ) : (
        <>
          {/* Tabla */}
          <div style={{ background:G.border }}>
            <div style={{ display:"grid", gridTemplateColumns:"40px 1fr 60px 60px 100px 120px", background:G.s2, padding:"8px 14px", gap:8 }}>
              {["Ícono","Nombre","Orden","Estado","Productos","Acciones"].map(h=>(
                <div key={h} style={{ fontFamily:G.sans, fontSize:8, letterSpacing:2, color:G.muted, textTransform:"uppercase", fontWeight:600 }}>{h}</div>
              ))}
            </div>
            {cats.map(cat=>(
              <div key={cat.id} style={{ display:"grid", gridTemplateColumns:"40px 1fr 60px 60px 100px 120px", background:G.s1, padding:"12px 14px", gap:8, borderBottom:`1px solid ${G.border}`, alignItems:"center", opacity:cat.activo?1:.5 }}>
                <div style={{ fontFamily:G.mono, fontSize:18, color:G.orange, textAlign:"center" }}>{cat.icono}</div>
                <div>
                  <div style={{ fontFamily:G.sans, fontSize:13, color:G.black, fontWeight:600 }}>{cat.nombre}</div>
                  {cat.descripcion && <div style={{ fontFamily:G.sans, fontSize:10, color:G.muted, marginTop:1 }}>{cat.descripcion.slice(0,60)}...</div>}
                </div>
                <div style={{ fontFamily:G.mono, fontSize:12, color:G.muted, textAlign:"center" }}>{cat.orden}</div>
                <div>
                  <span style={{ fontFamily:G.mono, fontSize:8, color:cat.activo?G.green:G.muted, border:`1px solid ${cat.activo?G.green:G.muted}`, padding:"2px 6px", letterSpacing:1, textTransform:"uppercase" }}>
                    {cat.activo?"Activa":"Inactiva"}
                  </span>
                </div>
                <div style={{ fontFamily:G.mono, fontSize:10, color:G.muted }}>— productos</div>
                <div style={{ display:"flex", gap:6 }}>
                  <button onClick={()=>setModal(cat)} style={{ fontFamily:G.mono, fontSize:13, color:G.blue, background:"none", border:"none", cursor:"pointer" }}>✎</button>
                  <button onClick={()=>toggleActivo(cat)} style={{ fontFamily:G.mono, fontSize:13, color:cat.activo?G.green:G.muted, background:"none", border:"none", cursor:"pointer" }}>◉</button>
                  <button onClick={()=>eliminar(cat)} style={{ fontFamily:G.mono, fontSize:13, color:G.red, background:"none", border:"none", cursor:"pointer" }}>✕</button>
                </div>
              </div>
            ))}
            {cats.length===0 && (
              <div style={{ background:G.s1, padding:32, textAlign:"center", fontFamily:G.sans, fontSize:12, color:G.muted }}>
                Sin categorías. Usá "Cargar categorías default" para empezar.
              </div>
            )}
          </div>

          {/* Vista previa del menú */}
          <div style={{ marginTop:24 }}>
            <div style={{ fontFamily:G.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", color:G.muted, marginBottom:12, fontWeight:600 }}>Vista previa del menú del catálogo</div>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              {cats.filter(c=>c.activo).map(c=>(
                <div key={c.id} style={{ display:"flex", alignItems:"center", gap:6, padding:"6px 14px", background:G.s1, border:`1.5px solid ${G.border}`, fontFamily:G.sans, fontSize:11, color:G.off }}>
                  <span style={{ fontFamily:G.mono, color:G.orange }}>{c.icono}</span>
                  {c.nombre}
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {modal && (
        <ModalCategoria
          cat={modal==="nueva" ? null : modal}
          onGuardar={()=>{ setModal(null); cargar(); }}
          onClose={()=>setModal(null)}
        />
      )}
    </div>
  );
}
